import { ca } from '@cian/analytics';

export type TBannerLocation =
  | 'after_pagination'
  | 'infinite'
  | 'before_pagination'
  | 'before_pagination_step2'
  | 'after_similar';

export const trackBannerShow = (bannerLocation: TBannerLocation) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: 'Banner',
    banner_location: bannerLocation,
  });
};

export const trackChangedUserType = (userType: string, bannerLocation: TBannerLocation) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: userType === 'homeowner' ? 'Change_to_owner' : 'Change_to_searcher',
    label: 'Banner',
    banner_location: bannerLocation,
  });
};

export const trackSendFormClick = (userType: string, bannerLocation: TBannerLocation) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_to_send',
    label: 'Page',
    selected_user_type: userType === 'homeowner' ? 'owner' : 'searcher',
    banner_location: bannerLocation,
  });
};
